import { ref as vueRef, watch, getCurrentInstance, onUnmounted } from "vue";
import { getDatabase, ref, onValue } from "firebase/database";
import { authStore } from "@/store/auth";

// Live subscription to the signed-in user's profile node. AccountView renders
// from this instead of a one-shot get() so direct RTDB writes made elsewhere
// in the app (e.g. the tab-bar language switcher writing selectedLanguage)
// update the page in place. isLoading covers only the first load per user;
// later snapshots patch the page silently.
export function useLiveUserInfo() {
  const userInfo = vueRef(null);
  const isLoading = vueRef(true);
  const db = getDatabase();

  // The listener follows authStore.userId: at mount the uid may not have
  // resolved yet, and it changes again on sign-out/sign-in.
  let off = null;
  const stopUserWatch = watch(
    () => authStore.userId,
    (userId) => {
      if (off) {
        off();
        off = null;
      }
      userInfo.value = null;
      isLoading.value = true;
      if (!userId) return;
      off = onValue(
        ref(db, `users/${userId}`),
        (snap) => {
          userInfo.value = snap.val() || {};
          isLoading.value = false;
        },
        (error) => {
          console.error("Failed to subscribe to user data:", error);
          isLoading.value = false;
        }
      );
    },
    { immediate: true }
  );
  if (getCurrentInstance()) {
    onUnmounted(() => {
      if (off) off();
      stopUserWatch();
    });
  }

  return { userInfo, isLoading };
}
